export default __webpack_public_path__ + "static/media/Testimony1.868ec38e.svg";